import tokenHttpClient from "../utils/httpClient";
import {
  post,
  postFile,
  getWithURLFileDownload,
} from "../utils/httpClient-methods";
import {
  API_URL,
  BASE_URL_MASTERS,
  BASE_URL,
  BRAND_LIST_API_URL,
  TECHNICAL_DOCUMENT_LIST_URL,
} from "../utils/AppApiUrl";
import { request } from "http";

export const TechnicalDocumentListService = async (requestBody) => {
  try {
    const requestObj = {
      technicalDocsPage: {
        pageSize: requestBody?.pageSize,
        pageNumber: requestBody?.pageNumber,
        sortDirection: requestBody?.sortDirection,
        sortBy: requestBody?.sortBy,
      },
      technicalDocsSearchParam: {
        brandId: requestBody?.brandId ?? null,
        categoryId: requestBody?.categoryId ?? null,
        modelName: requestBody?.modelName ?? null,
        docTypeId: requestBody?.docTypeId ?? null,
        productFamilyId: requestBody?.productFamilyId ?? null,
        brickId: requestBody?.brickId ?? null,
        techDocDesc: requestBody?.techDocDesc ?? null,
        deptId: requestBody?.deptId ?? null,
        userType: requestBody?.userType ?? null,
      },
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${TECHNICAL_DOCUMENT_LIST_URL.fetchTechnicalDocumentList}`,
      requestObj
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const getTechVersion = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.getTechVersion}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadTechDocHistoryService = async (requestBody) => {
  try {
    const response = await getWithURLFileDownload(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadTechDocHistoryService}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
}

export const getTechDocListService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceGetTechDocListing}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
       return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const AllBrandListingService = async () => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getAllBrandsListing}`,
      null
    );
    // add condition here to check
    if (response.status === 200) {
       return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const categoryListingService = async (values) => {
  try {
    const categoryListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.categoryListing}`,
      values
    );
    // add condition here to check
    if (categoryListingResponse.status === 200) {
      return categoryListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const docTypeListingService = async (typeId) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${TECHNICAL_DOCUMENT_LIST_URL.getDocTypeListing}?type=${typeId}`
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ModelListing_By_BrickService = async (brickId, brandId) => {
  try {
    const param = {
      brickId,
      brandId,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceAdvisoryModelListing}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const ModelDeptListing_By_BrickService = async (brickId, brandId,docName1) => {
  try {
 
    const param={
      "brickId": brickId,
      "brandId": brandId,
      "docName": docName1
    }
    const response = await post(
      tokenHttpClient,
    `${BASE_URL}${API_URL.techDocModelDeptListing}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const UploadFileService = async (file, requestBody) => {
  try {
    let formData = new FormData();
    if (file) {
      formData.append("file", file);
      formData.append("docTypeId", requestBody.docTypeId);
      formData.append("modelId", requestBody.modelId);
      formData.append("createdBy", requestBody.createdBy);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("sendNotification", requestBody.sendNotification);
      formData.append("shortDesc", requestBody.shortDesc);
      formData.append("techDocDesc", requestBody.techDocDesc);
      formData.append("deptId", requestBody.deptId);
    }
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${TECHNICAL_DOCUMENT_LIST_URL.uploadFile}`,
      formData
    );
    // add condition here to check
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const UploadFileServiceSoftware = async (file, requestBody, name, size, url) => {
  try {
    let formData = new FormData();
    //if (file) {
     // formData.append("file", file);
     formData.append("fileName", name);
     formData.append("fileSize", size);
     formData.append("uploadedUrl", url);
      formData.append("docTypeId", requestBody.docTypeId);
      formData.append("modelId", requestBody.modelId);
      formData.append("createdBy", requestBody.createdBy);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("sendNotification", requestBody.sendNotification);
      formData.append("shortDesc", requestBody.shortDesc);
      formData.append("techDocDesc", requestBody.techDocDesc);
      formData.append("deptId", requestBody.deptId);
   // }
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${TECHNICAL_DOCUMENT_LIST_URL.uploadFileSoftware}`,
    
      formData
    );
    // add condition here to check
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
export const UpdateFileServiceSoftware = async (file, requestBody, name, size, url) => {
  try {
    let formData = new FormData();
    if (file) {
     formData.append("id", requestBody.id);
     formData.append("fileName", name);
     formData.append("fileSize", size);
     formData.append("uploadedUrl", url);
      formData.append("docTypeId", requestBody.docTypeId);
      formData.append("modelId", requestBody.modelId);
      formData.append("modifiedBy", requestBody.createdBy);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("sendNotification", requestBody.sendNotification);
      formData.append("shortDesc", requestBody.shortDesc);
      formData.append("techDocDesc", requestBody.techDocDesc);
      formData.append("deptId", requestBody.deptId);
    }
    else{
      formData.append("id", requestBody.id);
       formData.append("docTypeId", requestBody.docTypeId);
       formData.append("modelId", requestBody.modelId);
       formData.append("modifiedBy", requestBody.createdBy);
       formData.append("isDownloadAble", requestBody.isDownloadAble);
       formData.append("sendNotification", requestBody.sendNotification);
       formData.append("shortDesc", requestBody.shortDesc);
       formData.append("techDocDesc", requestBody.techDocDesc);
       formData.append("deptId", requestBody.deptId);
    }
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${TECHNICAL_DOCUMENT_LIST_URL.updateFileSoftware}`,
    //`http://10.25.130.237:8888/technical_doc/api/v1/update-docs-software`,

      formData
    );
    // add condition here to check
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};



export const UpdateFileService = async (file, requestBody) => {
  try {
    let formData = new FormData();
    if (file) {
      formData.append("file", file);
      formData.append("id", requestBody.id);
      formData.append("modelId", requestBody.modelId);
      formData.append("deptId", requestBody.deptId);
      formData.append("docTypeId", requestBody.docTypeId);
      formData.append("modifiedBy", requestBody.createdBy);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("sendNotification", requestBody.sendNotification);
      formData.append("shortDesc", requestBody.shortDesc);
      formData.append("techDocDesc", requestBody.techDocDesc);
    }
    else{
      formData.append("id", requestBody.id);
      formData.append("modelId", requestBody.modelId);
      formData.append("deptId", requestBody.deptId);
      formData.append("docTypeId", requestBody.docTypeId);
      formData.append("modifiedBy", requestBody.createdBy);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("sendNotification", requestBody.sendNotification);
      formData.append("shortDesc", requestBody.shortDesc);
      formData.append("techDocDesc", requestBody.techDocDesc);
    }
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${TECHNICAL_DOCUMENT_LIST_URL.updateFile}`,
      formData
    );
    // add condition here to check
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadTechDocService = async (id) => {
  try {
    const response = await getWithURLFileDownload(
      tokenHttpClient,
      `${BASE_URL}${API_URL.getTechnicalDocs}`,
      {
        id,
      }
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const ChangeTechDocStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.changeTechDocStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const getAllDropDownService = async (
  brandId,
  brickId,
  productFamilyId,
  categoryId,
  reqBodyType
) => {
  const reqBody = {
    brandId: brandId ?? null,
    brickId: brickId ?? null,
    productFamilyId: productFamilyId ?? null,
    categoryId: categoryId ?? null,
    type: reqBodyType,
  };
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getAllDropDownList}`,
      reqBody
    );
    // add condition here to check
    if (response.status === 200) {
     
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const getAllDropDownListService = async () => {
  const reqBody = null;
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getAllDropDown}`,
      reqBody
    );
    // add condition here to check
    if (response.status === 200) {
     
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const getModelandDeptDetailService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.modelAndDeptDetail}?docName=${requestBody.docName}`,
      null
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};


export const deleteTechDocService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.deleteTechDoc}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err
  }
};